import moment from 'moment'

const monthsBetweenDates = (startDate: moment.Moment, endDate: moment.Moment) => {
  const now = startDate,
    dates = []

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format('YYYY-MM'))
    now.add(1, 'months')
  }
  return dates
}

export const monthsInYear = () => {
  const fromDate = startOfYear()
  const toDate = moment()

  return monthsBetweenDates(fromDate, toDate)
}

export const monthFromDate = (date: string) => {
  return moment(date).month() + 1
}

export const startOfYear = () => {
  return moment().subtract(11, 'month').startOf('month')
}

export const currentMonth = () => {
  return moment().month() + 1
}

export const previousMonth = () => {
  const month = currentMonth()
  // Check if current month is January
  return month == 1 ? 12 : month - 1
}
